import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import QualityManual_Form from "./qualityManual_Form/QualityManual_Form";
import QualityManual_table from "./qualityManual_table/QualityManual_table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/structural_requirement/management_data/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function QualityManual() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const management_data = useSelector((state) => state.management_data);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(FixIDS.management_data.List);
  const haveAddPermission = permissions?.includes(FixIDS.quality_manual.Add); //form

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        management_data_id: 1,
        page,
        per_page: management_data.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Quality Manual" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              The Quality Manual defines the laboratory’s quality management
              system, outlining policies, objectives, procedures, and
              responsibilities to ensure consistent service quality. It serves
              as a reference for maintaining compliance with standards, ensuring
              accuracy in testing, and promoting continual improvement in all
              laboratory operations.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          {haveAddPermission && (
            <QualityManual_Form fetchCustomers={fetchCustomers} />
          )}
        </div>

        <div className="imperiality_table_div">
          {haveReadPermission && (
            <QualityManual_table
              data={management_data}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              fetchCustomers={fetchCustomers}
            />
          )}
        </div>

        {/* <div className="m-3">
          <div className="add_another_holder">
            <div>
              <span>
                <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
              </span>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
}

export default QualityManual;
